import { Link } from "react-router-dom";
import { useLang } from "../../i18n/LanguageContext";

const PARTNERS = [
  { name: "Europäische Union", src: "/partners/eu.svg", href: "https://european-union.europa.eu" },
  { name: "Puro.earth", src: "/partners/puro.svg", href: "https://puro.earth" },
  { name: "EURAF", src: "/partners/euraf.png", href: "https://euraf.net" },
  { name: "biotech.hr", src: "/partners/biotech.png", href: "https://www.biotech.hr" },
];

export const Footer = () => {
  const { t } = useLang();
  const c = t.contact;

  return (
    <footer data-testid="footer">
      {/* Partner band — light, logos in grey/black */}
      <div className="bg-white border-y border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-16">
          <div className="grid grid-cols-2 lg:grid-cols-4 border-t border-l border-border">
            {PARTNERS.map((p, i) => (
              <a
                key={i}
                href={p.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center justify-center border-b border-r border-border h-28 px-8 hover:bg-background transition-colors"
                data-testid={`partner-${i}`}
                aria-label={p.name}
              >
                <img
                  src={p.src}
                  alt={p.name}
                  className="max-h-12 w-auto object-contain grayscale brightness-50 opacity-80 group-hover:grayscale-0 group-hover:brightness-100 group-hover:opacity-100 transition duration-300"
                />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Dark footer */}
      <div className="bg-nero-black text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
          <div className="grid md:grid-cols-12 gap-10">
            <div className="md:col-span-6">
              <img src="/nerochar-logo.png" alt="NeroChar" className="h-6 w-auto logo-white" />
              <p className="mt-6 font-heading text-sm font-medium tracking-tight text-nero-green">
                Black Carbon. Green Future.
              </p>
            </div>

            <div className="md:col-span-4 md:col-start-9">
              <div className="font-body text-xs uppercase tracking-[0.22em] font-semibold text-white/40 mb-5">
                {t.footer.contactTitle}
              </div>
              <div className="space-y-2 font-body text-sm text-white/65">
                <p className="text-white font-medium" data-testid="footer-brand">NeroChar</p>
                <p>powered by SRC Global GmbH</p>
                <p>{c.address1}</p>
                <p>{c.address2}</p>
                <a href={`tel:${c.phone.replace(/\s/g, "")}`} className="block hover:text-nero-green transition-colors">{c.phone}</a>
                <a href={`mailto:${c.email}`} className="block hover:text-nero-green transition-colors">{c.email}</a>
              </div>
            </div>
          </div>

          <div className="mt-14 pt-7 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="font-body text-xs text-white/35">
              © {new Date().getFullYear()} SRC Global GmbH — NeroChar. {t.footer.rights}
            </p>
            <div className="flex items-center gap-6">
              <Link to="/agb" className="font-body text-xs text-white/55 hover:text-nero-green transition-colors" data-testid="footer-agb">
                {t.footer.agb}
              </Link>
              <Link to="/datenschutz" className="font-body text-xs text-white/55 hover:text-nero-green transition-colors" data-testid="footer-privacy">
                {t.footer.privacy}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
